import { c as _c } from "react/compiler-runtime";
import AlertErrorIcon from '@precis-digital/kurama/icons/AlertErrorIcon';
import AlertInfoIcon from '@precis-digital/kurama/icons/AlertInfoIcon';
import AlertWarningIcon from '@precis-digital/kurama/icons/AlertWarningIcon';
import type { ReactElement, Ref, SVGProps } from 'react';
import { createSVGElement, extractSVGForDOM, extractSVGForReact, type SVGDOMInfo, type SVGReactInfo } from 'shared/utils/svg';
import type { AlertIcon, AlertType } from './types';
const ALERT_ICONS: Record<AlertType, AlertIcon> = {
  info: AlertInfoIcon,
  warning: AlertWarningIcon,
  error: AlertErrorIcon
};
export function getAlertSVGInfoForDOM(alert: undefined, iconsContainerId?: string): null;
export function getAlertSVGInfoForDOM(alert: AlertType, iconsContainerId?: string): SVGDOMInfo;
export function getAlertSVGInfoForDOM(alert: AlertType | undefined, iconsContainerId?: string): SVGDOMInfo | null;
export function getAlertSVGInfoForDOM(alert: AlertType | undefined, iconsContainerId = 'icon-templates'): SVGDOMInfo | null {
  if (alert == null) return null;
  return extractSVGForDOM(document.querySelector<SVGSVGElement>(`#${iconsContainerId} svg[data-alert-type="${alert}"]`));
}
export function getAlertSVGInfoForReact(alert: undefined, iconsContainerId?: string): null;
export function getAlertSVGInfoForReact(alert: AlertType, iconsContainerId?: string): SVGReactInfo;
export function getAlertSVGInfoForReact(alert: AlertType | undefined, iconsContainerId?: string): SVGReactInfo | null;
export function getAlertSVGInfoForReact(alert: AlertType | undefined, iconsContainerId = 'icon-templates'): SVGReactInfo | null {
  if (alert == null) return null;
  return extractSVGForReact(document.querySelector<SVGSVGElement>(`#${iconsContainerId} svg[data-alert-type="${alert}"]`));
}
interface AlertSVGElementProps {
  size?: string;
  x?: string;
  y?: string;
}
export function createAlertSVGElement(alert: undefined, props?: AlertSVGElementProps): null;
export function createAlertSVGElement(alert: AlertType, props?: AlertSVGElementProps): SVGSVGElement;
export function createAlertSVGElement(alert: AlertType | undefined, props?: AlertSVGElementProps): SVGSVGElement | null;
export function createAlertSVGElement(alert: AlertType | undefined, props?: AlertSVGElementProps): SVGSVGElement | null {
  const svgInfo = getAlertSVGInfoForDOM(alert);
  if (svgInfo == null) return null;
  const {
    size = '1em',
    x = '0',
    y = '0'
  } = props ?? {};
  const svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
  svg.setAttribute('viewBox', svgInfo.viewBox);
  if (size != null) {
    svg.setAttribute('width', size);
    svg.setAttribute('height', size);
  }
  if (x != null) svg.setAttribute('x', x);
  if (y != null) svg.setAttribute('y', y);
  svgInfo.children.forEach(child => {
    svg.appendChild(createSVGElement(child));
  });
  return svg;
}
interface AlertSymbolProps extends SVGProps<SVGSVGElement> {
  alert?: AlertType | null;
  ref?: Ref<SVGSVGElement>;
}
const AlertSymbol = t0 => {
  const $ = _c(8);
  let alert;
  let props;
  let ref;
  if ($[0] !== t0) {
    ({
      alert,
      ref,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = alert;
    $[2] = props;
    $[3] = ref;
  } else {
    alert = $[1];
    props = $[2];
    ref = $[3];
  }
  if (alert == null) {
    return null;
  }
  const AlertSymbolComponent = ALERT_ICONS[alert];
  let t1;
  if ($[4] !== AlertSymbolComponent || $[5] !== props || $[6] !== ref) {
    t1 = <AlertSymbolComponent {...props} ref={ref} />;
    $[4] = AlertSymbolComponent;
    $[5] = props;
    $[6] = ref;
    $[7] = t1;
  } else {
    t1 = $[7];
  }
  return t1;
};
export default AlertSymbol;